<template>
  <v-app-bar
      class="toolbar app-header"
      app
      fixed
      dense
      height="126px"
      padding="0"
      flat
      style="max-width: 1440px; margin: 0 auto;"
  >
    <v-navigation-drawer v-model="drawer" app class="show_mobile">
      <template v-slot:prepend>
        <v-list-item two-line>
          <UserAvatar :item="user" :size="'36'" style="top: -6px;"/>

          <v-list-item-content>
            <v-list-item-title>{{ user.first_name + ' ' + user.last_name }}</v-list-item-title>
            <v-list-item-subtitle>Logged In</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <div class="pa-2">
          <v-btn
              class="router-link"
              v-for="(item, index) in profile_items"
              :key="index"
              @click="onClickProfileMenu(item)"
              block
          >{{ item.title }}
          </v-btn>
        </div>
      </template>

      <v-divider></v-divider>

      <v-list dense>
        <div
            v-if="this.$store.getters['Authenticate/userRole'] === 'vendor' || this.$store.getters['Authenticate/userRole'] === 'employee'">
          <v-list-item link to="/vendor/users" v-if="accountEnabledPermission">
            <v-list-item-content>Users</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/vendor/app-display-information" v-if="accountEnabledPermission">
            <v-list-item-content>App Display Information</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/vendor/billing">
            <v-list-item-content>Account</v-list-item-content>
          </v-list-item>

<!--          <v-list-item link to="/vendor/report">-->
<!--            <v-list-item-content>Reports</v-list-item-content>-->
<!--          </v-list-item>-->

          <v-list-item link to="/vendor/invoices">
            <v-list-item-content>#Invoice</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/vendor/support">
            <v-list-item-content>Support</v-list-item-content>
          </v-list-item>

          <!-- <v-list-item link to="/owner/home-files">
            <v-list-item-content>Home Files</v-list-item-content>
          </v-list-item> -->
        </div>
        <div
            v-if="this.$store.getters['Authenticate/userRole'] === 'owner' || this.$store.getters['Authenticate/userRole'] === 'agent'">
          <v-list-item link to="/owner/users">
            <v-list-item-content>Agents</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/owner/vendors">
            <v-list-item-content>Vendor Users</v-list-item-content>
          </v-list-item>
          <v-list-item link to="/owner/vendor-coverage">
            <v-list-item-content>Vendor Coverage</v-list-item-content>
          </v-list-item>
          <v-list-item link to="/owner/vendor-recommendations">
            <v-list-item-content>Vendor Referrals</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/owner/clients">
            <v-list-item-content>Homeowners</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/owner/marketing">
            <v-list-item-content>Marketing</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/owner/invoices" v-if="user.user_role !== 'super_user'">
            <v-list-item-content>#Invoice</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/owner/account" v-if="user.user_role !== 'super_user'">
            <v-list-item-content>Account</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/owner/billing" v-if="user.user_role !== 'super_user'">
            <v-list-item-content>Billing</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/owner/crm" v-if="user.user_role !== 'super_user'">
            <v-list-item-content>CRM</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/owner/supports" v-if="user.user_role !== 'super_user'">
            <v-list-item-content>Support</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/owner/sms-logs" v-if="user.user_role === 'super_user'">
            <v-list-item-content>SMS</v-list-item-content>
          </v-list-item>

          <v-list-item link to="/owner/app-version-management" v-if="user.user_role === 'super_user'">
            <v-list-item-content>App Versions</v-list-item-content>
          </v-list-item>
          <!-- <v-list-item link to="/owner/home-files">
            <v-list-item-content>Home Files</v-list-item-content>
          </v-list-item> -->
        </div>
      </v-list>
      <!--            <template v-slot:append>-->
      <!--                <div class="pa-2">-->
      <!--                    <v-btn-->
      <!--                            class="router-link"-->
      <!--                            v-for="(item, index) in profile_items"-->
      <!--                            :key="index"-->
      <!--                            @click="onClickProfileMenu(item)"-->
      <!--                            block-->
      <!--                    >{{ item.title }}-->
      <!--                    </v-btn>-->
      <!--                </div>-->
      <!--            </template>-->
    </v-navigation-drawer>

    <v-toolbar-items class="menus-right header-logo" style="position: absolute; left: 0;">
      <router-link :to="homePath" class="header-logo-link">
        <img :src="require('@/assets/logo.svg')" alt width="150" style="width: 142px;"/>
      </router-link>
      <NavPayment :text="`You need to update your payment information to access additional functionality in Kiey`" v-if="!paymentPermission && tenant_billing_state !== 'cancelled'"/>
    </v-toolbar-items>
    <v-app-bar-nav-icon
        v-if="this.$store.getters['Authenticate/userRole'] === 'vendor' || this.$store.getters['Authenticate/userRole'] === 'owner' || this.$store.getters['Authenticate/userRole'] === 'employee' || this.$store.getters['Authenticate/userRole'] === 'agent'"
        class="show_mobile"
        @click.stop="drawer = !drawer"
    ></v-app-bar-nav-icon>
    <v-toolbar-title
        class="logo"
        style="position: absolute; margin-left:0; bottom: 0; width: 100%; text-align: center"
    >
      <div
          class="logged-menu-items-vendor show_desk"
          style="display: inline-block"
          v-if="this.$store.getters['Authenticate/userRole'] === 'vendor' || this.$store.getters['Authenticate/userRole'] === 'employee'"
      >
        <router-link
            v-if="accountEnabledPermission"
            to="/vendor/users"
            active-class="active"
            class="router-link"
            style="min-width: 88px;"
        >
          <v-btn text color="#061D47" width="88px" class="font-weight-black t-b-theme f-16">Users</v-btn>
        </router-link>
        <router-link
            v-if="accountEnabledPermission"
            to="/vendor/app-display-information"
            active-class="active"
            class="router-link"
            style="width: 212px;"
        >
          <v-btn
              text
              color="#061D47"
              width="212px"
              class="font-weight-black t-b-theme f-16"
          >App Display Information
          </v-btn>
        </router-link>
        <router-link
            to="/vendor/billing"
            active-class="active"
            class="router-link"
            style="min-width: 62px;"
        >
          <v-btn text color="#061D47" width="62px" class="font-weight-black t-b-theme f-16">Account</v-btn>
        </router-link>
<!--        <router-link-->
<!--            to="/vendor/report"-->
<!--            active-class="active"-->
<!--            class="router-link"-->
<!--            style="min-width: 84px;"-->
<!--        >-->
<!--          <v-btn text color="#061D47" width="84px" class="font-weight-black t-b-theme f-16">Reports</v-btn>-->
<!--        </router-link>-->
        <router-link
            to="/vendor/invoices"
            active-class="active"
            class="router-link"
            style="min-width: 89px;"
        >
          <v-btn
              text
              color="#061D47"
              width="89px"
              class="font-weight-black t-b-theme f-16"
          >#Invoice
          </v-btn>
        </router-link>
        <router-link
            to="/vendor/support"
            active-class="active"
            class="router-link"
            style="min-width: 89px;"
        >
          <v-btn text color="#061D47" width="89px" class="font-weight-black t-b-theme f-16">Support</v-btn>
        </router-link>
        <!-- <router-link
            to="/owner/home-files"
            active-class="active"
            class="router-link"
            style="min-width: 89px;"
        >
          <v-btn text color="#061D47" width="89px" class="font-weight-black t-b-theme f-16">Home Files</v-btn>
        </router-link> -->
      </div>
      <div
          class="logged-menu-items-owner show_desk"
          style="display: inline-block"
          v-if="this.$store.getters['Authenticate/userRole'] === 'owner' || this.$store.getters['Authenticate/userRole'] === 'agent'"
      >
        <router-link to="/owner/users" active-class="active" class="router-link" style="min-width: 80px;">
          <v-btn text color="#061D47" class="font-weight-black t-b-theme f-16">Agents</v-btn>
        </router-link>
        <router-link to="/owner/vendors" active-class="active" class="router-link" style="min-width: 80px;">
          <v-btn text color="#061D47" class="font-weight-black t-b-theme f-16">Vendors</v-btn>
        </router-link>
        <router-link to="/owner/clients" active-class="active" class="router-link" style="min-width: 80px;">
          <v-btn text color="#061D47" class="font-weight-black t-b-theme f-16">Homeowners</v-btn>
        </router-link>
        <router-link to="/owner/marketing" active-class="active" class="router-link" style="min-width: 80px;">
          <v-btn text color="#061D47" class="font-weight-black t-b-theme f-16">Marketing</v-btn>
        </router-link>
        <router-link to="/owner/alerts" active-class="active" class="router-link" style="min-width: 80px;">
          <v-btn text color="#061D47" class="font-weight-black t-b-theme f-16">Alerts</v-btn>
        </router-link>
        <router-link to="/owner/invoices" active-class="active" class="router-link" style="min-width: 80px;"
                     v-if="user.user_role !== 'super_user'">
          <v-btn text color="#061D47" class="font-weight-black t-b-theme f-16">#Invoice</v-btn>
        </router-link>
        <router-link to="/owner/account" active-class="active" class="router-link" style="min-width: 80px;"
                     v-if="user.user_role !== 'super_user'">
          <v-btn text color="#061D47" class="font-weight-black t-b-theme f-16">Account</v-btn>
        </router-link>
        <router-link to="/owner/billing" active-class="active" class="router-link" style="min-width: 80px;"
                     v-if="user.user_role !== 'super_user'">
          <v-btn text color="#061D47" class="font-weight-black t-b-theme f-16">Billing</v-btn>
        </router-link>
        <router-link to="/owner/crm" active-class="active" class="router-link" style="min-width: 80px;"
                     v-if="user.user_role !== 'super_user'">
          <v-btn text color="#061D47" class="font-weight-black t-b-theme f-16">CRM</v-btn>
        </router-link>
        <router-link to="/owner/supports" active-class="active" class="router-link" style="min-width: 80px;"
                     v-if="user.user_role !== 'super_user'">
          <v-btn text color="#061D47" class="font-weight-black t-b-theme f-16">Support</v-btn>
        </router-link>
        <router-link to="/owner/sms-logs" active-class="active" class="router-link"
                     v-if="user.user_role === 'super_user'">
          <v-btn text color="#061D47" width="72px" class="font-weight-black t-b-theme f-16">SMS</v-btn>
        </router-link>
        <router-link to="/owner/app-version-management" active-class="active" class="router-link"
                     v-if="user.user_role === 'super_user'">
          <v-btn text color="#061D47" class="font-weight-black t-b-theme f-16">App Versions</v-btn>
        </router-link>
        <!-- <router-link to="/owner/home-files" active-class="active" class="router-link">
          <v-btn text color="#061D47" width="89px" class="font-weight-black t-b-theme f-16">Home Files</v-btn>
        </router-link> -->
      </div>
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-toolbar-items
        class="hidden-sm-and-down menus-right"
        style="position: absolute; right: 0; margin-right: 42px; margin-top: -9px;height: 45px;"
    >
      <button
          v-if="isSuperUserAliased"
          type="button"
          @click="returnToSuperAdmin"
          title="Back to Super User"
          style="display:inline-flex; align-items:center; gap:6px; height:32px; margin-top:7px; margin-right:12px; padding:0 12px; border:1px solid #dbe3f0; background:#fff; border-radius:16px; color:#29ABE2; font-weight:600; font-size:13px; cursor:pointer; letter-spacing:0; transition:background 160ms ease, border-color 160ms ease;"
          onmouseover="this.style.background='#f5f9ff'; this.style.borderColor='#afc2eb';"
          onmouseout="this.style.background='#fff'; this.style.borderColor='#dbe3f0';"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
        Super User
      </button>
      <span v-if="getTenantName()" style="color: #061D47; font-weight: 600; font-size: 14px; margin-top: 10px; margin-right: 12px;">Team: {{ getTenantName() }}</span>
      <v-btn
          text
          style="padding-right: 0px;padding-left: 0px;"
          icon @click="showModal"
          v-if="tenants.length > 1"

      >
        <span class="icon-account-reactivate-outline icon-red" style="font-size: 40px; color: black;"/>
      </v-btn>

      <v-menu left bottom style="z-index: 10;top: 68px !important;">
        <template v-slot:activator="{ on }">
          <v-btn text v-on="on">
            <div class="header-profile-pic">
              <v-avatar
                  v-if="!user.profile_picture"
                  color="primary"
                  size="34"
              ><span class="white--text">{{ user.first_name.charAt(0) + user.last_name.charAt(0) }}</span></v-avatar>
              <img v-if="user.profile_picture" :src="user.profile_picture" alt/>
              <p>
                <span>{{ user.first_name }}</span>
                <span>{{ user.last_name }}</span>
              </p>

            </div>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
              v-for="(item, index) in profile_items"
              :key="index"
              @click="onClickProfileMenu(item)"
              class="menu-logged-options"
          >
            <v-list-item-title class="menu-option">{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <tenant-modal ref="tenantModal" :show="showTenantModal" :hide="hideTenantModal" :user="user" :tenants="tenants"
                    :onInactive="onInactive"/>
      <ChangeRoleModal
          :title="showChangeRoleModalTitle"
          :show="showChangeRoleModal"
          :hide="closeChangeRoleModal"
          :confirm="confirmEraseAccount"
          :state="deleting_status"
      />
      <RoleChangedModal
          :show="showRoleChangedModal"
          :hide="closeRoleChangedModal"
      />
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
  import UserAvatar from "@/components/UserAvatar";
  import TenantModal from "./modals/switch_modal";
  import {mapState, mapGetters} from "vuex";
  import {firestore} from "@/config/firebase";
  import AccountMixin from "@/mixins/account";
  import NavPayment from '@/components/nav/NavPayment.vue';
  import PaymentMixin from '@/mixins/payment';

  export default {
    name: "SiteHeader",
    created() {
      this.initTenantsList();
    },
    mixins: [AccountMixin, PaymentMixin],
    computed: {
      ...mapState({
        user: state => state.Authenticate.user
      }),
      ...mapGetters('Authenticate', ['tenant_billing_state']),
      homePath() {
        const role = this.user && this.user.user_role;
        if (role === 'owner' || role === 'super_user' || role === 'agent') {
          return '/owner/owner-admin-panel';
        }
        if (role === 'vendor' || role === 'employee') {
          return '/vendor/vendor-admin-panel';
        }
        return '/';
      },
      isSuperUserAliased() {
        const flag = typeof localStorage !== 'undefined' && localStorage.getItem('is_super_user') === 'true';
        const hasBackup = typeof localStorage !== 'undefined' && !!localStorage.getItem('super_user_return');
        const currentRole = this.user && this.user.user_role;
        return flag && hasBackup && currentRole && currentRole !== 'super_user';
      },
    },
    data: () => ({
      image: require("@/assets/logo.svg"),
      drawer: false,
      profile_items: [
        {
          title: "Logout",
          route: "/login",
          icon: ""
        }
      ],
      showTenantModal: false,
      tenants: [],
      subscriptions: [],
      totalNotifications: 0
    }),
    components: {
      UserAvatar,
      "tenant-modal": TenantModal,
      NavPayment
    },
    methods: {
      onClickProfileMenu(item) {
        try {
          switch (item.title) {
            case "Logout": {
              this.$store.dispatch("Authenticate/logout");
              this.$store.dispatch("Banner/hide");
              this.$router.push(item.route);
              break;
            }
            default: {
              this.$router.push("/login");
              break;
            }
          }
        } catch (error) {
          //
        }

      },
      showModal() {
        this.showTenantModal = true;
      },
      hideTenantModal() {
        this.showTenantModal = false;
      },
      async returnToSuperAdmin() {
        let backup = null;
        try {
          const raw = localStorage.getItem('super_user_return');
          if (raw) backup = JSON.parse(raw);
        } catch (e) {
          console.warn('[returnToSuperAdmin] Failed to parse backup:', e);
        }

        if (!backup || !backup.options || !backup.options.is_system_super_user) {
          // No usable backup — clean up stale flags and fall back to full logout.
          console.warn('[returnToSuperAdmin] No usable options backup, falling back to logout', backup);
          localStorage.removeItem('is_super_user');
          localStorage.removeItem('super_user_return');
          this.$store.dispatch('Authenticate/logout');
          this.$router.push('/login').catch(() => {});
          return;
        }

        // Flag + safety_logout + navigate. /login's mounted hook will restore
        // options and open the modal. Firebase session stays valid so when the
        // user picks a tenant, activate_ut can mint a fresh tenant token.
        // Dispatch (not commit) so the action's cross-store cleanups fire —
        // otherwise the previous tenant's Chat / Users_list / Vendors_list /
        // Call state lingers into the super-user session (audit Item #6).
        localStorage.setItem('return_to_super_user', 'true');
        await this.$store.dispatch('Authenticate/safety_logout');
        this.$router.push('/login').catch(() => {});
      },
      async initTenantsList() {
        this.tenants = [];
        if (this.user && this.user.tenants_list) {
          let tenant_ids = [];

          for (const tenant of this.user.tenants_list) {
            tenant_ids.push(tenant.tenant_id);
          }

          let size = 10;
          let tenant_ids_split = [];
          for (let i = 0; i < tenant_ids.length; i += size) {
            tenant_ids_split.push(tenant_ids.slice(i, i + size));
          }

          let subusers = {};
          const subUserPromises = tenant_ids.map(tid =>
            firestore
              .collection("tenants").doc(tid).collection("users")
              .where("owner_id", "==", this.user.owner_id)
              .get().catch(error => console.error(error))
          );
          const subUserResults = await Promise.all(subUserPromises);
          for (const subUserSnap of subUserResults) {
            if (subUserSnap) {
              for (const doc of subUserSnap.docs) {
                subusers[doc.data().tenant_id] = {
                  ...doc.data(),
                  id: doc.id
                };
              }
            }
          }

          for (const tenant_ids of tenant_ids_split) {
            const tenantsRef = await firestore
              .collection("tenants")
              .where("id", "in", tenant_ids)
              .get().catch(error => console.error(error));
            if (!tenantsRef) continue;
            for (const tenantRef of tenantsRef.docs) {
              let haveSomeTenantBillingActive = false;
              let tenant = {};
              if (this.user.owner_id !== tenantRef.data().owner_id) {
                const subuser = subusers[tenantRef.id];
                if (subuser) {
                  tenant = this.user.tenants_list.find(x => x.tenant_id === tenantRef.id && x.role === subuser.user_role);
                  if (subuser.is_active === false) {
                    continue;
                  }
                }
              } else {
                tenant = this.user['tenants_list'].find(x => x.tenant_id === tenantRef.id && x.role === "owner");
              }
              if (tenantRef.exists) {
                if (tenantRef.data().billing_active === true || tenantRef.data().billing_active === undefined) {
                  haveSomeTenantBillingActive = true;
                }
              }

              let canAddTenant = false;
              if (["agent", "vendor", "employee"].includes(tenant.role) && tenant.status === "inactive") {
                canAddTenant = false;
              } else if (haveSomeTenantBillingActive && (tenant.status === undefined || tenant.status !== 'inactive') && !["client", "owner", "vendor", "super_user"].includes(tenant.role)) {
                canAddTenant = true;
              } else if (haveSomeTenantBillingActive && ["owner", "vendor"].includes(tenant.role) && tenant.role !== "client") {
                canAddTenant = true;
              } else if (["super_user"].includes(tenant.role)) {
                canAddTenant = true;
              }

              if (canAddTenant) {
                if (!this.tenants.find(x => x.tenant_id === tenant.tenant_id)) {
                  this.tenants.push({
                    ...tenant
                  });
                }
              }
            }
          }
        }
      },
      getTenantName() {
        const currentTenantId = this.user.tenant_current_logged || this.$store.state.Chat.tenant_id;
        if (!currentTenantId) return '';
        // Check loaded tenants first
        const tenant = this.tenants.find(t => t.tenant_id === currentTenantId);
        if (tenant && tenant.company_name) return tenant.company_name;
        // Fallback to tenants_list on user object
        if (this.user.tenants_list) {
          const entry = this.user.tenants_list.find(t => t.tenant_id === currentTenantId);
          if (entry && entry.company_name) return entry.company_name;
        }
        return '';
      },
      confirmAccount(tenant) {
        // TODO when old account was been erased
        this.$refs.tenantModal.onSelectTenant(tenant);
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "../../assets/css/icons";

  .f-16 {
    font-size: 16px !important;
  }


  .login-btn {
    color: #fff !important;
    width: 155px;
    box-shadow: 0 5px 18px rgba(51, 51, 51, 0.13) !important;
    border-radius: 24px !important;
    background-color: #29abe2 !important;
  }

  /* toolbar header */
  .toolbar {
    height: 125px !important;
    background: #fff !important;
  }

  .v-toolbar__items > .v-btn.login-btn {
    height: 48px !important;
    margin-top: 37px;
  }

  .t-b-theme {
    text-transform: capitalize !important;
  }

  .header-logo-link {
    margin-left: 115px;
    margin-top: 32px;
  }

</style>
